module.exports = __webpack_public_path__ + "img/arrow-down.546c5cf1.svg";